import { render, staticRenderFns } from "./Slide6.vue?vue&type=template&id=51ba5ed3&scoped=true&"
import script from "./Slide6.vue?vue&type=script&lang=js&"
export * from "./Slide6.vue?vue&type=script&lang=js&"
import style0 from "./Slide6.vue?vue&type=style&index=0&id=51ba5ed3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba5ed3",
  null
  
)

export default component.exports